import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';

import { AutoInfo } from '@autos/auto-results/entities/auto-info';
import { TransmissionTypes } from '@autos/auto-results/entities/filters';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-auto-info-view',
  templateUrl: './auto-info-view.component.html',
  styleUrls: ['./auto-info-view.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoInfoViewComponent {

  @Input() data: AutoInfo;

  public iconColor = IconFillColor.Primary;
  public fontColor = TypographyColor.Primary;

  get fontSize(): TypographyFontSize {
    return TypographyFontSize.XXS;
  }

  get icon(): typeof Icon {
    return Icon;
  }

  get passengers(): string {
    return this.data?.passengers ?? '';
  }

  get doors(): string {
    return this.data?.doors ?? '';
  }

  get baggage(): string {
    return this.data?.baggage ?? '';
  }

  get hasBaggage(): boolean {
    return this.baggage && +this.baggage > 0;
  }

  get airConditioned(): string {
    return (this.data?.air_conditioned) ? 'AUTOS_MODULE.DETAILS.AIR_CONDITIONED.TRUE' :
      'AUTOS_MODULE.DETAILS.AIR_CONDITIONED.FALSE';
  }

  get transmission(): string {
    return (this.data?.transmission.toUpperCase() === TransmissionTypes.Automatic) ?
      'AUTOS_MODULE.CARD.TRANSMISSION.AUTOMATIC' : 'AUTOS_MODULE.CARD.TRANSMISSION.MANUAL';
  }
}
